export const BACK_TO_EXIT_MESSAGE = 'Pressione novamente para fechar o app'
export const BACK_TO_EXIT_WINDOW_MS = 2500

interface BackToExitOptions {
  now: () => number
  toast: (message: string, durationMs: number) => void
  exit: () => void
  windowMs?: number
}

export interface BackToExit {
  press: () => 'toast' | 'exit'
  reset: () => void
}

/** BACK-16: só o botão nativo na raiz pode armar a saída por duplo voltar. */
export const createBackToExit = ({
  now,
  toast,
  exit,
  windowMs = BACK_TO_EXIT_WINDOW_MS,
}: BackToExitOptions): BackToExit => {
  let lastPressAt: number | null = null

  return {
    press: () => {
      const time = now()
      if (lastPressAt !== null && time - lastPressAt < windowMs) {
        lastPressAt = null
        exit()
        return 'exit'
      }
      lastPressAt = time
      toast(BACK_TO_EXIT_MESSAGE, windowMs)
      return 'toast'
    },
    reset: () => { lastPressAt = null },
  }
}
